const translations = {
  page_title: 'Dealer',
  settings: 'Settings',
  costs: 'Costs',
  inventory: 'Inventory',
  users: 'Users',
  deal_products: 'Deal products',
  analytics: 'Analytics',

  add_new_account: 'Add New Dealer',
  add_account: 'New Dealer',
  new_account_general: 'General',
  new_account_location: 'Location',
  new_account_admin: 'Admin',
  new_account_plan: 'Plan',

  section_general: 'General',
  section_general_description:
    'Enter the basic dealer information. Keep it updated to maximize sales opportunities.',
  dealer_logo: 'Account logo',
  logo: 'Logo',

  invalid_value: 'Invalid value',
  field_changed_error: 'There was an error',
  field_changed_success: 'Field updated successfully',

  name: 'Name',
  dealer_name: 'Account name',
  enter_name: 'Enter name',

  phone: 'Phone number',
  dealer_phone: 'Account phone number',
  enter_phone: 'Enter phone number',

  whatsapp: 'Whatsapp number',
  dealer_whatsapp: 'Account Whatsapp number',
  enter_whatsapp: 'Enter Whatsapp number',

  email: 'Email',
  dealer_email: 'Account email',
  enter_email: 'Enter email',

  section_location: 'Location',
  section_location_description:
    'Provide the necessary information so that customers can locate you and reach the dealer easily.',

  country: 'Country',
  dealer_country: 'Account country',
  enter_country: 'Enter country',

  region: 'Region',
  dealer_region: 'Account region',
  enter_region: 'Enter region',

  city: 'City',
  dealer_city: 'Account city',
  enter_city: 'Enter city',

  address: 'Address',
  dealer_address: 'Account address',
  enter_address: 'Enter address',

  postal_code: 'Zip code',
  dealer_postal_code: 'Account zip code',
  enter_postal_code: 'Enter zip code',

  address_url: 'Address URL',
  address_map_url: 'Address map URL',

  alliances: 'Alliances',
  section_alliances_description:
    'Add here all those dealers you want to share information and vehicles with.',
  remove_account: 'Remove alliance',
  // TODO: cambiar por texto real
  remove_account_description:
    'Nec tellus sit morbi risus bibendum sit. Arcu interdum feugiat accumsan sed feugiat molestie. Auctor ac mauris ipsum.',
  add_alliance: 'Add alliance',
  select_accounts: 'Select accounts to add',
  add_alliances: 'Add alliances',
  account_info: 'Account info',

  site: 'Site',

  url: 'Site URL',
  enter_url: 'Enter URL',

  watermark_logo: 'Watermark logo',
  watermark_position: 'Watermark position',
  enter_watermark_position: 'Choose watermark position',
  watermark_remove_description: 'Are you sure you want to remove the watermark?',
  watermark_remove_title: 'Remove watermark',
  no_watermark_uploaded: 'No watermark uploaded',
  landing_phone: 'Landing phone',
  enter_landing_phone: 'Choose landing phone',

  permissions: 'Permissions',
  section_permissions_description:
    'Set general account permissions. What you change here will apply to all users.',
  permission_pages_sellers_can_edit_pages: 'Sellers can edit pages',
  ['pages.sellers_can_edit_pages_description']: 'Will be able to edit the info on their sites',
  permission_pages_email: 'Pages email',
  ['pages.email_description']: 'Email shown in sites and landing pages',
  permission_vehicles_sellers_can_edit_vehicles: 'Sellers can edit vehicles',
  ['vehicles.sellers_can_edit_vehicles_description']:
    'Will be able to edit the info on every vehicle',
  permission_vehicles_videos: 'Vehicles videos',
  ['vehicles.videos_description']: 'Display a video in the vehicle detail page',
  permission_dealer_site: 'Dealer site',
  ['dealer.site_description']: 'Managers can create a site from the mobile app',
  permission_dealer_deals: 'Deals section',
  permission_dealer_pricing: 'Pricing section',
  ['dealer.pricing_description']: 'Display pricing insights',
  ['dealer.deals_description']: 'Dealer has access to the deals section',
  permission_landings_videos: 'Landings videos',
  ['landings.videos_description']: 'Attach a video to a shared landing page',
  permission_contacts_list: 'Contacts list',
  ['contacts.list_description']: 'Display a list of leads and clients',
  permission_seller_site: 'Seller site',
  ['seller.site_description']: 'Sellers can create their own site from the mobile app',
  add_email: 'Add email',
  permission_can_remove_bg: 'Remove vehicle background',
  ['vehicles.can_remove_bg_description']: 'Remove background with AI',
  permission_vehicles_marketing: 'Vehicle marketing',
  ['vehicles.marketing_description']: 'Marketing options for vehicles',
  permission_vehicles_edit_price_and_cost_roles: 'Vehicle price & costs',
  ['vehicles.edit_price_and_cost_roles_description']: 'Roles allowed to edit vehicle price & costs',
  permission_vehicles_edit_price_and_cost_roles_modal: 'Edit vehicle price & costs',
  ['vehicles.managers_can_edit_vehicles_description']:
    'Will be able to edit the info on every vehicle',
  permission_vehicles_managers_can_edit_vehicles: 'Managers can edit vehicles',
  ['vehicles.managers_can_expire_vehicles_description']:
    'Will be able to expire the info on every vehicle',
  permission_vehicles_managers_can_expire_vehicles: 'Managers can expire vehicles',
  show_price: 'Show price',
  show_price_description: 'Show vehicle price on wordpress, landings and dynamic pages',
  dealer_site: 'Dealer site',
  dealer_site_description: 'Show vehicle price on the main dealer website',
  seller_sites: 'Seller sites',
  seller_sites_description: 'Show vehicle price on individual seller websites',
  landing_pages: 'Landing pages',
  landing_pages_description: 'Show vehicle price on marketing landing pages',
  price_priority: 'Price priority',
  price_priority_description:
    'Set the priority of the vehicle prices. Move to the right column to ignore a price.',
  price_prefix: 'Price prefix',
  price_suffix: 'Price suffix',
  price_prefix_suffix: 'Price prefix & suffix',
  price_prefix_suffix_description: 'Set prefix and suffix text that will appear before and after vehicle prices',
  price_prefix_placeholder: 'Enter prefix',
  price_suffix_placeholder: 'Enter suffix',
  price_prefix_max_length: 'Prefix must be less than 50 characters',
  price_suffix_max_length: 'Suffix must be less than 50 characters',
  active_prices: 'Active prices',
  ignored_prices: 'Ignored prices',

  plan: 'Active plan',
  section_plan_description:
    'Info about the contracted plan. Here you will find the details or request an upgrade.',
  plan_details: 'Plan details',
  payment: 'Payment',
  user_accounts: 'User accounts',
  enter_user_accounts: 'Enter user accounts',
  vehicles: 'Vehicles',
  enter_vehicles: 'Enter vehicles',
  agent_websites: 'Agent websites',
  enter_agent_websites: 'Enter agent websites',
  background_remove: 'Background remove credits',
  enter_background_remove: 'Enter background remove credits',
  agent_websites_error:
    'The agent websites number can not be greater than the user accounts number',
  monthly_plan_1_name: 'Plan 1',
  monthly_plan_1_description: '40 active vehicles, 10 active users',
  monthly_plan_2_name: 'Plan 2',
  monthly_plan_2_description: '80 active vehicles, 10 active users',
  monthly_plan_3_name: 'Plan 3',
  monthly_plan_3_description: '200 active vehicles, 10 active users',
  monthly_plan_7_name: 'Plan 4',
  monthly_plan_7_description: '500 active vehicles, 20 active users',
  repeated_admin_email: 'The email is already in use',
  repeated_admin_username: 'The username is already in use',

  importers: 'Importers',
  section_importers_description:
    'Add here all the necessary information sources to keep your inventory always up to date.',
  remove_importer: 'Remove importer',
  // TODO: cambiar por texto real
  remove_importer_description:
    'Nec tellus sit morbi risus bibendum sit. Arcu interdum feugiat accumsan sed feugiat molestie. Auctor ac mauris ipsum.',
  add_importer: 'Add importer',

  integrations: 'Integrations',
  section_integrations_description:
    'Services through which the inventory is exported in various media.',
  remove_integration: 'Remove integration',
  // TODO: cambiar por texto real
  remove_integration_description:
    'Nec tellus sit morbi risus bibendum sit. Arcu interdum feugiat accumsan sed feugiat molestie. Auctor ac mauris ipsum.',
  add_integration: 'Add integration',

  share_type_dealer: "Dealer's phone",
  share_type_user: 'Phone from the user who shared the vehicle',

  watermark_top_left: 'Top left',
  watermark_top_right: 'Top right',
  watermark_center: 'Center',
  watermark_bottom_left: 'Bottom left',
  watermark_bottom_right: 'Bottom right',

  integration: 'Integration',

  change_plan: 'Change plan',
  monthly: 'Monthly',
  monthly_short: 'mo',
  custom: 'Custom',

  inventory_labels: 'Inventory labels',
  section_inventory_description:
    'The labels allow you to manage the visibility and promotion of vehicles in the inventory, making it easier for customers to identify the best opportunities and optimizing their purchasing experience.',
  inventory_locations: 'Inventory locations',
  section_inventory_locations_description:
    'List of locations where vehicles can be located. Used when editing a vehicle.',
  enter_location: 'Enter location',
  edit_location: 'Edit location',
  remove_location: 'Remove location',
  remove_location_description: 'Are you sure you want to remove this location?',
  remove_fleet: 'Remove fleet',
  remove_fleet_description: 'Are you sure you want to remove this fleet?',
  location_added_successfully: 'The location was added successfully',
  location_edited_successfully: 'The location was edited successfully',
  location_deleted_successfully: 'The location was deleted successfully',
  location_already_exists: 'The location already exists',
  location_has_vehicles: 'The location has vehicles assigned to it',
  fleet_has_vehicles: 'The fleet has vehicles assigned to it',
  add_location: 'Add location',
  labels: 'Labels',
  discount: 'Discount coupon',
  discount_placeholder: 'Discount',
  discount_expires: 'Discount expiration',
  discount_description: 'Shows that the vehicle has a discount bonus',
  featured: 'Featured',
  featured_placeholder: 'Featured',
  featured_expires: 'Featured expiration',
  featured_description: 'Marks the vehicle as featured.',
  on_sale: 'On sale',
  on_sale_placeholder: 'On sale',
  on_sale_expires: 'On sale expiration',
  on_sale_description: 'Marks the vehicle as a special offer.',
  recently_added: 'Recently added',
  recently_added_placeholder: 'Recently added',
  recently_added_expires: 'Recently added expiration',
  recently_added_description: 'Shows that the vehicle is new to the inventory',
  expires_placeholder: 'Expires',
  down_price: 'Down price',
  down_price_placeholder: 'Down price',
  down_price_expires: 'Down price expiration',
  down_price_description: 'Shows that the vehicle is priced below market value',
  price_drop: 'Price drop',
  price_drop_placeholder: 'Price drop',
  price_drop_expires: 'Price drop expiration',
  price_drop_description: 'Shows that the vehicle has had a price drop',
  sold: 'Sold',
  sold_placeholder: 'Sold',
  sold_expires: 'Sold expiration',
  sold_description: 'Marks the vehicle as sold and disables contact options',
  days: 'days',
  active_for_n_days: 'Active for {{n}} days',
  active_indefinitely: 'Active indefinitely',
  set_days: 'Set days',

  fleets: 'Fleets',
  section_fleets_description:
    'Fleets are groups of vehicles that can be managed together. This allows for easier organization and management of multiple vehicles at once.',
  add_fleet: 'Add fleet',
  edit_fleet: 'Edit fleet',

  //Users
  active_users: 'Active users',
  section_users_description:
    'These are the registered users of the dealer. Here you can edit their info and permissions.',
  add_new_user: 'Add new user',
  delete_user: 'Delete User',
  delete_user_description: 'You are about to delete this user, this action cannot be undone.',
  new_user: 'New User',
  create_user: 'Create user',
  user_first_name: 'First Name',
  enter_first_name: 'Enter first name',
  user_last_name: 'Last Name',
  enter_last_name: 'Enter last name',
  user_email: 'Email',
  user_phone: 'Phone',
  user_role: 'Role',
  choose_role: 'Choose user role',
  user_username: 'Username',
  username: 'Username',
  enter_username: 'Enter username',
  user_password: 'Password',
  repeat_password: 'Repeat password',
  enter_password: 'Enter password',
  appadmin: 'App admin',
  seller: 'Seller',
  promoter: 'Promoter',
  super_admin: 'Super Admin',
  manager: 'Manager',
  admin: 'Admin',
  staff: 'Staff',
  photographer: 'Photographer',
  finance_manager: 'Finance Manager',
  user_added_success: 'User added successfully',
  user_removed_success: 'User removed successfully',
  max_limit_reached: 'You have reached the maximum amount for your account',
  user_limit_reached: 'You have reached the maximum amount of users for your account',
  inventory_max_limit_reached:
    'You have reached the maximum amount of vehicles for your subscription plan',

  section_account: 'Account',
  section_account_description:
    'These are its login credentials. You can edit them to recover or block the access.',
  section_personal_info: 'Personal info',
  section_personal_info_description:
    'These are the personal data. Keep them updated to make it easier to get in touch with this user.',

  avatar: 'Avatar',
  user: 'User',
  role: 'Role',
  last_time_online: 'Last time online',

  change_role: 'Change role',

  add_new_api_key: 'Create api key',
  yes: 'Yes',
  no: 'No',
  id: 'Id',
  description: 'Description',
  custom_key: 'Custom key',
  delete_apikey: 'Delete api key',
  delete_apikey_description: 'You are about to delete this api key, this action cannot be undone.',

  inventory_feeds: 'Feeds',
  section_inventory_feeds_description: 'Feeds description',

  pages: 'Pages',
  pages_description: 'Unpublish user pages for this account',

  api_key: 'Api key',
  inventory_google_url: 'Google Ads Feed URL',
  inventory_facebook_url: 'Facebook Feed URL',
  feed_url_copied: 'Feed url successfully copied!',

  make_and_model: 'Makes and models',

  section_pages: 'Personal site',
  section_pages_description:
    'Basic information of the site generated in the mobile app. To edit it you will have to use the mobile app.',

  domain: 'Domain',
  domain_placeholder: 'Enter domain',
  invalid_domain: 'Invalid domain',

  subdomain: 'Subdomain',
  subdomain_placeholder: 'Enter subdomain',
  invalid_subdomain: 'Invalid subdomain',

  position: 'Position',
  position_placeholder: 'Enter position',
  invalid_position: 'Invalid position',

  whatsapp_placeholder: 'Enter whatsapp',
  invalid_whatsapp: 'Invalid whatsapp',

  calendar_embed: 'Calendar embed',
  calendar_embed_placeholder: 'Enter calendar embed',
  invalid_calendar_embed: 'Invalid calendar embed',

  additional_dealers: 'Additional Dealers',

  user_no_pages: 'The user has no pages.',

  section_marketing: 'Marketing',
  section_marketing_description:
    'Set the preferred options that suits best your inventory marketing and sales goals.',

  facebook_pixel_id: 'Facebook pixel id',
  facebook_pixel_id_placeholder: 'Enter Facebook pixel id',
  invalid_facebook_pixel_id: 'Invalid value',
  remove_facebook_pixel_id: 'Remove Facebook pixel id',
  remove_facebook_pixel_id_description: 'Are you sure you want to remove Facebook pixel id?',

  section_social_media: 'Social media accounts',
  section_social_media_description:
    "List of links to the user's social networks. These are displayed on the sites and landing pages generated in the app.",
  add_social_media: 'Add social media',
  remove_social_media: 'Remove social media',
  remove_social_media_description: 'Are you sure you want to remove this social media?',
  social_media_added_success: 'Social media added successfully',
  social_media_updated_success: 'Social media updated successfully',
  social_media_removed_success: 'Social media removed successfully',
  you_have_no_social_media: 'You have no social media added yet',

  facebook: 'Facebook',
  instagram: 'Instagram',
  linkedIn: 'Linkedin',
  twitter: 'Twitter',
  youtube: 'Youtube',

  select_media: 'Select media',
  select_media_placeholder: 'Select media',
  social_media_username: 'Username',
  enter_social_media_username: 'Enter username',
  invalid_social_media_username: 'Invalid username',

  recurrent_costs: 'Recurrent costs',
  recurrent_costs_description:
    'Enter and manage recurring costs associated with the acquisition and maintenance of a vehicle. Keeping these costs updated aids in accurate financial forecasting and budgeting.',
  add_cost: 'Add cost',
  edit_cost: 'Edit cost',

  custom_packs: 'Custom packs',
  custom_packs_description:
    'Define and manage custom packages of recurring costs. This helps in organizing and simplifying the management of ongoing expenses related to vehicle acquisition and upkeep.',
  add_package: 'Add package',
  edit_package: 'Edit package',

  suppliers: 'Suppliers',
  suppliers_description:
    'Manage your supplier companies information. Keep it updated to optimize coordination and ensure the smooth operation of your business.',
  add_supplier: 'Add supplier',
  edit_supplier: 'Edit supplier',

  invalid_vehicle_condition: 'Invalid condition',
  vehicle_condition_placeholder: 'Select condition',

  vehicle_type: 'Vehicle type',
  invalid_vehicle_type: 'Invalid type',
  vehicle_type_placeholder: 'Select type',

  automatic_assignment: 'Automatically assign to',
  vehicle_condition: 'Assign to',
  automatic_assignment_short: 'Auto. assign',

  notes: 'Notes',
  invalid_notes: 'Invalid notes',
  notes_placeholder: 'Enter notes',

  name_placeholder: 'Enter name',
  invalid_name: 'Invalid name',

  email_placeholder: 'Enter email',
  invalid_email: 'Invalid email',

  phone_placeholder: 'Enter phone',
  invalid_phone: 'Invalid phone',

  address_placeholder: 'Enter address',
  invalid_address: 'Invalid address',

  no_costs_added: 'No costs added yet',
  no_packages_added: 'No packages added yet',
  no_suppliers_added: 'No suppliers added yet',

  costs_amount: 'Costs amount',

  remove_cost: 'Delete cost',
  remove_costs: 'Delete costs',
  cost_remove_description:
    'Existing cost and its receipt will be deleted. Are you sure you want to remove this cost?',
  costs_remove_description: 'Are you sure you want to remove all the selected cost?',
  remove_package: 'Delete package',
  package_remove_description: 'Are you sure you want to remove the package?',
  remove_supplier: 'Delete supplier',
  supplier_remove_description: 'Are you sure you want to remove the supplier?',
  supplier_already_exists: 'The supplier already exists',

  cost_added_successfully: 'The cost was added successfully',
  cost_added_successfully_warning:
    'The cost was added successfully but some receipts could not be uploaded',
  cost_edited_successfully: 'The cost was edited successfully',
  cost_edited_successfully_warning:
    'The cost was edited successfully but some receipts could not be uploaded',
  cost_deleted_succesfully: 'The cost was deleted successfully',
  costs_deleted_succesfully: 'The costs were deleted successfully',

  package_added_successfully: 'The package was added successfully',
  package_edited_successfully: 'The package was edited successfully',
  package_deleted_succesfully: 'The package was deleted successfully',
  package_already_exists: 'The package already exists',

  supplier_added_successfully: 'The supplier was added successfully',
  supplier_edited_successfully: 'The supplier was edited successfully',
  supplier_deleted_successfully: 'The supplier was deleted successfully',

  ftp_info: 'FTP Info',
  ftp_host: 'HOST',
  ftp_user: 'USER',
  ftp_pass: 'PASS',
  ftp_last_run: 'Last run',
  ftp_last_update: 'Last update',
  importer_config: 'Importer config',
  importer: 'Importer',
  importer_placeholder: 'Select importer',
  config: 'Config',
  config_placeholder: 'Enter config',
  delete_importer: 'Delete importer',
  delete_importer_description: 'Are you sure you want to delete this importer?',
};

export default translations;
